import React from 'react';
import PropTypes from 'prop-types';

const ExpandWidthIcon = ({color = 'currentColor', ...props}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.83292 16.8335V0.833496M3.09973 10.8335L0.833008 8.65168M0.833008 8.65168L3.09973 6.46986M0.833008 8.65168H6.42858M14.5663 6.46986L16.833 8.65168M16.833 8.65168L14.5663 10.8335M16.833 8.65168L11.2374 8.65168"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>

);

ExpandWidthIcon.propTypes = {
  color: PropTypes.string,
};

export default ExpandWidthIcon;
